export default function csrfToken() {
  let tokenEl = document.querySelector('meta[name="csrf-token"]');
  if (!tokenEl) return null;
  return tokenEl.attributes.getNamedItem('content')?.value;
}
